var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoupon = function SvgCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.895 2.158Zm0 0a.917.917 0 0 1 .32-.147c.035-.008.054-.01.057-.01H14v4.727a.916.916 0 0 1-.123.33c-.02.034-.033.047-.033.048v-.001l-.014.015-6.472 6.723-5.202-5.201 6.724-6.47.015-.014ZM9.272 0c-.345 0-.688.094-.964.209a2.593 2.593 0 0 0-.82.527L.493 7.466l-.012.012A1.637 1.637 0 0 0 .48 9.794v.001l5.726 5.725c.638.64 1.678.64 2.315 0l.012-.012 6.731-6.994a2.59 2.59 0 0 0 .528-.821A2.59 2.59 0 0 0 16 6.728v-5.09C16 .735 15.267 0 14.363 0H9.272ZM11 6.001a1 1 0 1 0 0-2 .999.999 0 1 0 0 2Z",
    clipRule: "evenodd"
  })));
};
export default SvgCoupon;